import React, { useEffect } from 'react';
import styled from 'styled-components';
import { WidgetArticleButtonType, WidgetDisplayMode } from 'jamespot-user-api';
import { Widget, WidgetEditor } from 'jamespot-front-business';
import { commonComponentsRegistry } from '../../../registry/CommonRegistry';
import { useAppDispatch } from '../../../redux/store';

const JRCWidgetButton = commonComponentsRegistry.getLazyComponent('WidgetButton');

const CSSButtonWrapper = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
`;

const CSSPointer = styled.div<{ clickable: boolean }>`
    pointer-events: ${(props) => (props.clickable ? 'all' : 'none')};
    cursor: pointer;
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
`;

export const JRCWidgetArticleButtonWrapper = ({
    widget,
    mode,
}: {
    widget: WidgetArticleButtonType;
    inplace: boolean;
    mode?: WidgetDisplayMode;
}) => {
    const dispatch = useAppDispatch();
    const { uniqid } = widget;
    const { text, url, target, color, backgroundColor, buttonSize, borderRadius, variant } = widget.content;

    useEffect(() => {
        dispatch(
            Widget.slice.actions.setWidgetState({
                uniqid,
                empty: !text || text.length === 0,
            }),
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [text]);

    return (
        <CSSButtonWrapper
            onClick={() => {
                if (mode === 'edit') {
                    dispatch(WidgetEditor.slice.actions.registerEditor({ uniqid, name: widget.name }));
                }
            }}>
            <CSSPointer clickable={mode !== 'edit'}>
                <JRCWidgetButton
                    text={text}
                    url={url}
                    target={target}
                    color={color}
                    backgroundColor={backgroundColor}
                    buttonSize={buttonSize}
                    borderRadius={borderRadius}
                    variant={variant}
                />
            </CSSPointer>
        </CSSButtonWrapper>
    );
};
